import React from "react";
import { TableCell, TableRow } from "@mui/material";

import { supplierInventoryApi } from "@/main/api";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import ButtonSuggestionIconForInput from "@/main/components/shared/buttonSuggestionIconForInput/buttonSuggestionIconForInput";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import { SupplierInventoryVehiclesRequest } from "@/main/models/request";
import { getTranslateByKey, isNullUndefinedEmpty } from "@/main/services/utils";

import { ISectionVehiclesState } from "../sectionVehicles";
import * as S from "./styles";

const EMPTY_VALUE = "--";

interface IVehicleGrid extends ISectionVehiclesState {
	isAPI: boolean;
}

interface IGridSectionVehiclesProps {
	request: SupplierInventoryVehiclesRequest | null;
	countryName?: string | null;
	vehicles: ISectionVehiclesState[];
	vehiclesAPI: ISectionVehiclesState[];
	setVehiclesAPI: React.Dispatch<React.SetStateAction<ISectionVehiclesState[]>>;
	handleDeleteVehicleInfo: (guidVehicle: string) => void;
}
function GridSectionVehicles({
	request,
	countryName,
	vehicles,
	vehiclesAPI,
	setVehiclesAPI,
	handleDeleteVehicleInfo,
}: IGridSectionVehiclesProps) {
	function getCountryLabel(vehicle: IVehicleGrid) {
		if (!isNullUndefinedEmpty(vehicle.country)) return vehicle.country;
		if (!isNullUndefinedEmpty(countryName)) return countryName;

		return EMPTY_VALUE;
	}

	async function fetchVehiclesInventory(request: any) {
		return supplierInventoryApi.getVehiclesInventory(request).then((response) => response.data);
	}

	if (!vehicles && !vehiclesAPI) return null;

	const mergedVehicles: IVehicleGrid[] = [
		...vehicles.map((vehicle) => ({
			...vehicle,
			isAPI: false,
		})),
		...vehiclesAPI.map((vehicle) => ({
			...vehicle,
			isAPI: true,
		})),
	];
	const ID_SCROLLABLE_TARGET = "id-scrollable-inventory-container-vehicles";

	return (
		<S.Container id={ID_SCROLLABLE_TARGET}>
			<KOGPaginationGrid
				showTitleResults
				showEndMessage={false}
				sumTotalRecords={vehicles.length}
				idScrollableTarget={ID_SCROLLABLE_TARGET}
				dataGrid={mergedVehicles}
				formFilters={request}
				setDataGrid={setVehiclesAPI}
				fetchMore={fetchVehiclesInventory}
			>
				<BoxGrid
					marginCustom="0"
					rowHeaders={[
						getTranslateByKey("information.country"),
						getTranslateByKey("information.make"),
						getTranslateByKey("information.model"),
						getTranslateByKey("information.trim"),
						getTranslateByKey("information.year"),
						"",
						"",
					]}
				>
					{mergedVehicles.map((vehicle) => (
						<TableRow key={vehicle.idClient}>
							<TableCell>{getCountryLabel(vehicle)}</TableCell>
							<TableCell>{vehicle.manufacturer}</TableCell>
							<TableCell>{vehicle.model}</TableCell>
							<TableCell>{vehicle.submodel}</TableCell>
							<TableCell>{vehicle.year}</TableCell>

							<TableCell width="5%" align="center">
								{vehicle.suggestion && <ButtonSuggestionIconForInput onClickCustom={() => {}} />}
							</TableCell>
							<TableCell width="5%" align="center">
								<S.IconClose onClick={() => handleDeleteVehicleInfo(vehicle.idClient)} />
							</TableCell>
						</TableRow>
					))}
				</BoxGrid>
			</KOGPaginationGrid>
		</S.Container>
	);
}

export default GridSectionVehicles;
